import { Link } from 'react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

/** Entry point to the GEICO Supergood regression suite. */
export function GeicoQaCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>GEICO regression</CardTitle>
        <CardDescription>
          Re-quote committed customer fixtures through GEICO Supergood and check each one still reaches a
          verdict. Creates real GEICO quotes; creates no orgs here.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild>
          <Link to="/insure/internal/qa/geico">Open regression suite</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
